/**
 * Logic — Textaufgaben & logisches Schließen.
 * Klassische Knobelaufgaben.
 */
export const LOGIC = [
  { id: 'log01', cat: 'logic', diff: 1,
    q: 'Wie viele Beine haben 3 Hühner und 2 Kühe zusammen?', a: '14',
    hint: 'Hühner haben 2, Kühe 4', exp: '3·2 + 2·4 = 6 + 8 = 14' },

  { id: 'log02', cat: 'logic', diff: 1,
    q: 'In einer Schale liegen 12 Äpfel. Du nimmst 4. Wie viele hast du?', a: '4',
    hint: 'Genau lesen', exp: 'Du hast die 4, die du genommen hast' },

  { id: 'log03', cat: 'logic', diff: 2,
    q: 'In einem Raum sind 5 Personen. Jeder gibt jedem die Hand. Wie viele Handschläge?', a: '10',
    hint: 'n·(n−1)/2', exp: '5·4/2 = 10' },

  { id: 'log04', cat: 'logic', diff: 2,
    q: 'Wie alt ist Anna, wenn sie in 5 Jahren doppelt so alt ist wie heute vor 5 Jahren?', a: '15',
    hint: 'x+5 = 2(x−5)', exp: 'x+5 = 2x−10 → x = 15' },

  { id: 'log05', cat: 'logic', diff: 2,
    q: 'Sind alle A B und alle B C, dann sind alle A auch C? (1=ja, 0=nein)', a: '1',
    hint: 'Transitivität', exp: 'A ⊆ B ⊆ C, also A ⊆ C' },

  { id: 'log06', cat: 'logic', diff: 2,
    q: 'Wie viele Minuten sind ein Viertel eines Tages?', a: '360',
    hint: '24·60 / 4', exp: '1440 / 4 = 360 Minuten' },

  { id: 'log07', cat: 'logic', diff: 3,
    q: 'Eine Uhr braucht 6 Sekunden für 7 Schläge. Wie lange für 11 Schläge?', a: '10',
    hint: 'Intervalle, nicht Schläge zählen', exp: '6 Intervalle = 6s → 1s pro Intervall. 11 Schläge = 10 Intervalle = 10s' },

  { id: 'log08', cat: 'logic', diff: 3,
    q: 'Ein Buch hat doppelt so viele Seiten wie ein zweites + 20. Zusammen 320. Wie viele hat das kleinere?', a: '100',
    hint: 'x + (2x+20) = 320', exp: '3x = 300 → x = 100' },

  { id: 'log09', cat: 'logic', diff: 3,
    q: 'Ein Bauer hat Hühner und Kaninchen. 20 Köpfe, 56 Beine. Wie viele Kaninchen?', a: '8',
    hint: 'System: x+y=20, 2x+4y=56', exp: 'y = 8 Kaninchen, x = 12 Hühner' },

  { id: 'log10', cat: 'logic', diff: 3,
    q: 'Wie viele 7er-Ziffern gibt es zwischen 1 und 100?', a: '20',
    hint: 'Einer- und Zehner-Position', exp: 'Einer: 7,17,...,97 = 10. Zehner: 70-79 = 10. Gesamt 20' },

  { id: 'log11', cat: 'logic', diff: 4,
    q: 'Wenn 2 Katzen in 2 Minuten 2 Mäuse fangen, wie viele Katzen für 100 Mäuse in 50 Min?', a: '4',
    hint: 'Eine Katze fängt 1 Maus in 2 Min', exp: '50 Min / 2 = 25 Mäuse pro Katze. 100/25 = 4 Katzen' },

  { id: 'log12', cat: 'logic', diff: 4,
    q: 'Bei einem Turnier spielt jeder gegen jeden. 28 Spiele insgesamt. Wie viele Teilnehmer?', a: '8',
    hint: 'n·(n−1)/2 = 28', exp: '8·7/2 = 28' },

  { id: 'log13', cat: 'logic', diff: 2,
    q: 'Wenn 3 Maler in 3 Tagen 3 Zimmer streichen, wie viele Tage braucht 1 Maler für 1 Zimmer?', a: '3',
    hint: 'Pro Maler/Zimmer-Verhältnis', exp: 'Ein Maler streicht ein Zimmer in 3 Tagen' },

  { id: 'log14', cat: 'logic', diff: 4,
    q: 'Drei aufeinanderfolgende gerade Zahlen ergeben summiert 78. Welche ist die kleinste?', a: '24',
    hint: 'x + (x+2) + (x+4) = 78', exp: '3x + 6 = 78 → x = 24' },

  { id: 'log15', cat: 'logic', diff: 3,
    q: 'Wie viel Uhr ist es, wenn der Stundenzeiger genau zwischen 4 und 5 steht und der Minutenzeiger auf 6?', a: '430',
    hint: '4:30 — als Zahl ohne Doppelpunkt', exp: 'Stundenzeiger genau zwischen 4 und 5 → halbe Stunde nach 4 = 4:30' },
];
